export default {
    // 资产证券
    equity:() => import( /* webpackChunkName: "equity" */ '../../views/default/special/equity/equity.vue'),
    /*中燃集团登录定制*/
    chinaGas:() => import( /* webpackChunkName: "chinaGas" */ '../../views/default/special/chainGas/chainGas.vue'),
    // 云租宣传页
    yz:() => import( /* webpackChunkName: "yz" */ '../../views/default/special/yz/yz.vue'),
    
    //云签登录-原合同管理登录界面
    yqLogin:() => import( /* webpackChunkName: "yqLogin" */ '../../views/default/special/yqLogin/yqLogin.vue'),

    
    // 页面迁移-登录前 
    // 易捷专题
    yijie:()=>import(/* webpackChunkName: "yijie" */'../../views/default/special/yijie/yijie.vue'),
    // 京投登录
    bilLogin:()=>import(/* webpackChunkName: "bil" */'../../views/default/special/bilLogin/bilLogin.vue'),
    // 天道金科登录
    tdftLogin:()=>import(/* webpackChunkName: "tdf" */'../../views/default/special/tdftLogin/tdftLogin.vue'),
    // 票转信专题
    // -产品介绍
    produceInfo:()=>import(/* webpackChunkName: "produceInfo" */'../../views/default/special/pzx/produceInfo.vue'),
    // -产品咨询
    produceZX:()=>import(/* webpackChunkName: "produceZX" */'../../views/default/special/pzx/produceZX.vue'),
    // 资产处置回收
    assetRecovery:()=>import(/* webpackChunkName: "assetRecovery" */'../../views/default/special/assetRecovery/assetRecovery.vue'),
   
    
    // 信用查询
    queryCompanyCredit:()=>import(/* webpackChunkName: "queryCompanyCredit" */'../../views/default/special/queryCompanyCredit/queryCompanyCredit.vue'),
    
    
    // 镇江专题
    // 镇江index
    zjindex:()=>import(/* webpackChunkName: "queryCompanyCredit" */'../../views/default/special/zhenjiang/index.vue'),
    // 镇江-云信
    zjyunxin:()=>import(/* webpackChunkName: "zjyunxin" */'../../views/default/special/zhenjiang/yunxin.vue'),
    // 镇江—云证
    zjyunzheng:()=>import(/* webpackChunkName: "zjyunzheng" */'../../views/default/special/zhenjiang/yunzheng.vue'),
    // 镇江—云投
    zjyuntou:()=>import(/* webpackChunkName: "zjyuntou" */'../../views/default/special/zhenjiang/yuntou.vue'),
    // 镇江—融资租赁
    zjrzzl:()=>import(/* webpackChunkName: "zjrzzl" */'../../views/default/special/zhenjiang/rzzl.vue'),
    // 镇江—票转信
    zjpzx:()=>import(/* webpackChunkName: "zjrzzl" */'../../views/default/special/zhenjiang/pzx.vue'),
    // 镇江—联系我们
    zjcontactUs:()=>import(/* webpackChunkName: "zjcontactUs" */'../../views/default/special/zhenjiang/contactUs.vue'),
    

    
    //新闻list
    new_content:() => import( /* webpackChunkName: "yunZhengMDfinace" */ '../../views/default/special/zhenjiang/new_content.vue'), 
    //新闻list
    new_detail:() => import( /* webpackChunkName: "yunZhengMDfinace" */ '../../views/default/special/zhenjiang/new_detail.vue'), 

    // 链信专题
    lianxin:()=>import(/* webpackChunkName: "lianxin" */'../../views/default/special/lianxin/lianxin.vue'),
    // 链信-官网-首页
    lianxinAppIntro:()=>import(/* webpackChunkName: "lianxinAppIntro" */'../../views/default/special/lianxin/lianxinAppIntro.vue'),

    // 融资租赁
    rzzl:()=>import(/* webpackChunkName: "rzzl" */'../../views/default/special/rzzl/rzzl.vue'),
     // 云投-旧
     yuntou_old:()=>import(/* webpackChunkName: "yuntou_old" */'../../views/default/special/yuntou/yuntou_old.vue'),
     // 云投
    yuntou:()=>import(/* webpackChunkName: "yuntou" */'../../views/default/special/yuntou/yuntou.vue'),
     // 政E信
     ZEXin:()=>import(/* webpackChunkName: "yuntou" */'../../views/default/special/ZEXin/ad.vue'),

    // 企业函证邮箱
    hzEmail:()=>import(/* webpackChunkName: "hzEmail" */'../../views/default/special/hzEmail/email.vue'),


    // 企业好友-邀请好友
    InviteFriends:()=>import(/* webpackChunkName: "InviteFriends" */'../../views/default/special/userCenter/InviteFriends.vue'),

    // 优惠券
    Coupons:()=>import(/* webpackChunkName: "Coupons" */'../../views/default/special/platformCoupon/platformCoupon.vue'),

    //链信 消息发送-公告通知 消息正文
    sendMessageType:()=>import(/* webpackChunkName: "Coupons" */'../../views/default/special/lianxin/sendMessageType.vue'),

}